import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

export const Glossary = () => {
    const { t } = useTranslation("dashboard");

    return (
        <Accordion
            sx={{ border: 0, borderRadius: 0, boxShadow: "none", position: "initial", margin: "0 !important", }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    minHeight: 0,
                    justifyContent: "start",
                    padding: 0,
                    "&.Mui-expanded": {
                        margin: 0,
                        minHeight: 0,
                    },
                    "& .MuiAccordionSummary-content": {
                        margin: 0,
                        flexGrow: 0,
                        "&.Mui-expanded": {
                            margin: "0 !important"
                        }
                    }
                }}
            >
                <Typography variant="overline">
                    {t("TrainingPanel.Glossary.Title")}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <ul>
                    <li><Trans i18nKey="TrainingPanel.Glossary.TargetUser" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.TargetTraining" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Adhesion" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Completion" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Conclusion" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Cancellation" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Overdue" t={t} /></li>
                    <br />
                    <li><Trans i18nKey="TrainingPanel.Glossary.ReactionEvaluation" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.EfficacyAssessment" t={t} /></li>
                    <li><Trans i18nKey="TrainingPanel.Glossary.Opinions" t={t} /></li>
                </ul>
            </AccordionDetails>
        </Accordion>
    );
};
